<template>
  <div>
    <FITModal ref="FormListModal" reference="modal" :title="$t('general.CURD.delete')" @click="onClickModalDelete">
      <div slot="body">
        <h5 class="mb-3">{{$t('dw.form.list.deleteModalMsg')}}</h5>
        <p class="my-2"><b>{{selectedRow.formEnglishName}}</b></p>
        <p class="my-2"><b>{{selectedRow.formChineseName}}</b></p>
      </div>
    </FITModal>
    <FITAlert ref="alert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
    <FITFormCard>
      <div slot='header'>
        <b-row>
          <b-col cols=8>
            <p class="h4">{{$t('dw.form.list.header')}}</p>
          </b-col>
          <b-col cols="4" class="text-right">
            <b-button v-if="permissionLevel<3.5" variant="primary" size="md" @click="createNewForm">{{ $t('dw.form.create.header') }}</b-button>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="table" :filters="filters" :actions="actions" :columns="columns" searchAction="getFormList" vuexModule="Dw" type="form"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { FITCheckbox, FITTextInput, FITSearchableTable, FITTable, FITFormCard, FITModal, FITAlert } from '@/components'
import { API, APIList } from '@/api'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'FormList',
  components: {
    FITSearchableTable,
    FITTextInput,
    FITTable,
    FITFormCard,
    FITModal,
    FITAlert
  },
  props: {
    alertContent: {
      type: String,
      default: null
    },
    alertVariant: {
      type: String,
      default: null
    }

  },
  data() {
    return {
      alertParams: {
        content: '',
        variant: 'success'
      },
      selectedRow: {},

      filters: [{
        label: this.$t('dw.form.list.formCategory'),
        key: 'formCategory',
        type: 'select',
        default: null, // Default All
      }, ],
      actions: [{
          key: 'download',
          text: this.$t('adm.document.download'),
          callback: (key, row, instance) => {
            window.open(row.formLink);
          }
        },
        {
          key: 'edit',
          text: this.$t('general.CURD.edit'),
          callback: (key, row, instance) => {

            this.$router.push({
              name: 'Form Create',
              params: { detail: row }
            });

          }
        },
        {
          key: 'delete',
          text: this.$t('general.CURD.delete'),
          class: 'text-danger',
          callback: (key, row, instance) => {
            Vue.set(this, 'selectedRow', row);
            this.$refs.FormListModal.openModal();
          }
        }
      ],
      columns: [
        { key: 'ID', label: this.$t('adm.document.fields.ID'), sortable: true },
        {
          key: 'providerName',
          label: this.$t('dw.form.list.providerName'),
          sortable: true,
          formatter: (row, key, item) => {
            return item.providerEnglishName + '<br/>' + item.providerChineseName;
          }
        },
        {
          key: 'formCategory',
          label: this.$t('dw.form.list.formCategory'),
          sortable: true,
          formatter: (row, key, item) => {
            console.log(row);
            return this.getTranslated(key, row);
          }
        },
        {
          key: 'formName',
          label: this.$t('dw.form.list.formName'),
          sortable: true,
          formatter: (row, key, item) => {
            return item.formEnglishName + '<br/>' + item.formChineseName;
          }
        },
        { key: 'remarks', label: this.$t('adm.document.fields.remarks'), sortable: true },
        { key: 'createTime', label: this.$t('adm.document.fields.createTime'), sortable: true },
      ],
    }
  },
  created() {
    if (this.alertContent) {
      this.setAlert();
      this.$refs.alert.showAlert();
    }
  },
  computed: {
    ...mapGetters(['getTranslatedArray']),
    permissionLevel(){
      return this.$store.state.permissionLevel;
    },
  },
  methods: {
    setAlert() {
      if (this.alertContent) {
        Vue.set(this.alertParams, 'content', this.alertContent);
      }
      if (this.alertVariant) {
        Vue.set(this.alertParams, 'variant', this.alertVariant);
      }
    },
    onClickModalDelete(evt) {
      if (evt) {
        this.$store.dispatch('Dw/deleteForm', { ID: this.selectedRow.ID }).then((json) => {
          this.$refs.table.search();
          this.$refs.FormListModal.closeModal();
          Vue.set(this, 'alertParams', { content: this.$t('general.deleteSuccess'), variant: 'success' });
          this.$refs.alert.showAlert();
          window.scrollTo(0, 0);
        })
      }
    },
    createNewForm() {
      this.$router.push('/dw/form/create');
    },
    onRowClicked(row) {
      console.debug(row)
    },
    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      if (type == "publicDocument") {
        if (key == "Y") { return "Yes"; } else { return "No"; }
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Dw', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
  }

}

</script>



// WEBPACK FOOTER //
// src/Dw/FormManagement/FormList.vue